export default __webpack_public_path__ + "static/mark-3a59b6684ce15e30d85294a7331bff69.png";